<template>
    <div class="row">
        <div class="col-md-8">
            <div class="page-header">
                <h3 class="page-title">
<!--                    <span class="page-title-icon bg-gradient-primary text-white mr-2" v-if="iconClass">-->
<!--                      <i :class="iconClass"></i>-->
<!--                    </span>-->
                    {{ title }}
                </h3>
            </div>
        </div>
        <div class="col-md-4">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageHeader",
    props: {
        iconClass: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true
        },
        useTitleAsDocumentTitle: {
            type: Boolean,
            default: true
        }
    },
    created() {
        if(this.useTitleAsDocumentTitle) {
            document.title = this.title + ' - AFORM';
        }
    }
}
</script>

<style scoped>

</style>
